// @ts-nocheck
import { createFromProduct, ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import {
    getProductCollectionRealTimeInventory,
    getProductCollectionRealTimePrices,
    getProductCollectionV2,
} from "@insite/client-framework/Services/ProductServiceV2";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { useWebsite } from "@store/Framework/Store/Context/ContextHooks";
import chunk from "lodash/chunk";
import { useState } from "react";

export interface ProductContextData {
    product: ProductModel | undefined;
    productInfo: ProductInfo | undefined;
}
export interface ProductContextsBySku {
    [sku: string]: ProductContextData;
}

const useProductContextsBySkus = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [productContextsBySku, setProductContextsBySku] = useState<ProductContextsBySku>({});
    const productPrefix = `${useWebsite().name.toUpperCase()}-`;

    const getProductContextsBySkus = async (skus: string[]): Promise<ProductContextsBySku | null> => {
        if (isLoading) {
            return null;
        }
        setIsLoading(true);

        const skuListChunks = chunk(skus, 40);
        const fixedSkuListChunks = skuListChunks.map(chunk => chunk.map(sku => `${productPrefix}${sku}`));
        const productsReturnList = await Promise.all(
            fixedSkuListChunks.map(chunk =>
                getProductCollectionV2({
                    productNumbers: chunk,
                }),
            ),
        );

        const productsReturn = productsReturnList.reduce(
            (acc, products) => {
                acc.products = acc.products.concat(products?.products || []);
                return acc;
            },
            { products: [] as ProductModel[] },
        );
        const receivedSKUS = productsReturn.products?.map(product => product.id);
        const productInfos = productsReturn.products?.map(product => createFromProduct(product));
        const [inventoryCollection, pricingCollection] = await Promise.all([
            getProductCollectionRealTimeInventory({
                productIds: receivedSKUS || [],
            }),
            getProductCollectionRealTimePrices({
                productPriceParameters: productInfos || [],
            }),
        ]);
        const productInfosWithInventoryAndPricing: ProductInfo[] =
            productInfos?.map(product => {
                const inventory = inventoryCollection.realTimeInventoryResults?.find(
                    inventory => inventory.productId === product.productId,
                );
                const pricing = pricingCollection.realTimePricingResults?.find(
                    pricing => pricing.productId === product.productId,
                );
                return {
                    ...product,
                    inventory: inventory || undefined,
                    pricing: pricing || undefined,
                };
            }) || [];
        const newProductContextBySku: ProductContextsBySku = {};
        productInfosWithInventoryAndPricing.forEach(productInfo => {
            const productItemNumber =
                productsReturn?.products
                    ?.find(product => {
                        return product.id === productInfo.productId;
                    })
                    ?.productNumber.replace("EA", "")
                    .replace(productPrefix, "") || productInfo.productId;

            newProductContextBySku[productItemNumber] = {
                product: productsReturn.products?.find(p => p.id === productInfo.productId) || undefined,
                productInfo,
            };
        });
        setProductContextsBySku(newProductContextBySku);
        setIsLoading(false);
        return newProductContextBySku;
    };
    return {
        productContextsBySku,
        getProductContextsBySkus,
        isLoading,
    };
};
export default useProductContextsBySkus;
